export const AreaType = {
  PRIMARY: 1,
  SECONDARY: 2
}